<template>
    <div class="minimize">
        <Card style="height:14vh">
            <template #title>
                Site Geographical Centre change
                <p class="p-component">Click the edit button. Center point circles will turn purple. Drag a point to
                    move it. Click done when finished.</p>
                <!--<Button icon="pi pi-window-maximize" class="p-button-rounded p-button-secondary p-button-text"
                    style="position:fixed;right:10px" @click="closeMenu" /> -->
            </template>
            <template #content>
                <div class="formgrid grid">
                    <!-- <div class="field col-12 md:col-4 fieldLabel">
                                    <div class="verticalBoxContainer"> 
                    <label for="drawbutton" class="field col-12 md:col-2 fieldLabel">:</label>-->
                    <Button id="drawbutton" label="Edit" icon="pi pi-pencil" @click="centerPointEdit"
                        class="field col-12 md:col-2 fieldLabel" v-if="editCenterPointMode == false" />
                    <Button id="savebutton" :label="changeSaveButtonLabel" icon="pi pi-check" @click="centerPointSave"
                        class="field col-12 md:col-2 fieldLabel" v-if="editCenterPointMode" />
                    <div class="field col-12 md:col-8 fieldLabel"></div>
                    <Button id="closebutton" label="Close" icon="pi pi-times" @click="closeMenu"
                        class="field col-12 md:col-2 fieldLabel" />


                </div>
            </template>
        </Card>
    </div>
</template>

<script>
import MapOL from "@/libs/myOpenLayers.js";

export default {
    data() {
        return {
            editCenterPointMode: false,
            saveButtonText: "Done",
        }
    },
    computed: {
        changeSaveButtonLabel() {
            return this.saveButtonText;
        },
    },
    methods: {
        switchSaveButtonLabel(textLabel) {
            this.saveButtonText = textLabel;
        },
        switchMode(mode) {
            this.editCenterPointMode = false;

            switch (mode) {
                case 7:
                    this.editCenterPointMode = true;
                    break;
                default:
            }
        },
        centerPointEdit() {
            this.switchMode(7);
            MapOL.moveCenterPoints();
        },
        centerPointSave() {
            this.switchSaveButtonLabel("Processing...");
            MapOL.processMoveCenterPoints();

            var self = this;

            setTimeout(function () {
                if (MapOL.isChangeCentralPointLocationMode() === false) {
                    self.switchSaveButtonLabel("Done");
                    self.switchMode(-1);
                }
                else {
                    var self2 = self;
                    console.log("pass");
                    setTimeout(function () {
                        if (MapOL.isChangeCentralPointLocationMode() === false) {
                            self2.switchSaveButtonLabel("Done");
                            self2.switchMode(-1);
                        }
                        else {
                            var self3 = self2;
                            console.log("pass 2x");
                            setTimeout(function () {
                                if (MapOL.isChangeCentralPointLocationMode() === false) {
                                    self3.switchSaveButtonLabel("Done");
                                    self3.switchMode(-1);
                                }
                                else {
                                    var self4 = self3;
                                    console.log("pass 3x");
                                    setTimeout(function () {
                                        if (MapOL.isChangeCentralPointLocationMode() === false) {
                                            self4.switchSaveButtonLabel("Done");
                                            self4.switchMode(-1);
                                        }
                                        else {
                                            console.log("pass 4x");
                                        }
                                    }, 1000);
                                }
                            }, 1000);
                        }
                    }, 1000);
                }
            }, 1000);

        },
        closeMenu() {
            MapOL.switchOffSiteDraw();
            this.switchMode(-1);
            this.$router.replace({ path: '/' });
        }
    }
}
</script>

<style>
.minimize {
    width: 40vw;
    position: absolute;
    transform: translate(70%, 0%);
    top: calc(100vh - 250px);
    height: 15vh;
    overflow: hidden;
    min-height: 150px;
}
</style>